import SelectInput from '../selectInput'
import { InputProps } from 'antd'
import { IOptionItem } from 'interfaces'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

export const StyleItemField = styled.div`
  flex: 1 1 calc(25% - 15px);
  // max-width: calc(25% - 15px);

  &.booking-infor {
    flex: 1 1 calc(20% - 16px);
    // max-width: calc(20% - 16px);
  }

  &.span-col-5 {
    flex: 1 1 calc(20% - 16px);
    // max-width: calc(20% - 16px);
  }

  &.panel-infor {
    flex: 1 1 calc(33% - 13px);
    // max-width: calc(33% - 13px);
  }
`
interface IProps extends InputProps {
  title?: string
  children?: ReactNode
  defaultValue?: string
  placeholder?: string
  preventInput?: boolean
  options?: Array<IOptionItem>
  typeInput?: 'number' | 'string'
  fixed?: number
  onChangeOption?: (value: any) => void
}

const InputUnit = (props: IProps) => {
  const { title, options, placeholder, onChangeOption, ...resProps } = props
  const { t } = useTranslation()
  return (
    <StyleItemField className="span-col-5">
      <SelectInput
        title={t(title || '')}
        options={options}
        placeholder={placeholder}
        onChangeOption={onChangeOption}
        {...resProps}
      />
    </StyleItemField>
  )
}

export default InputUnit
